import React, { useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import { useSelector } from "react-redux";

// Config
import { getRoute, urls } from "src/config/routes";

// Components
import FurtherInfoPanel from "../../components/FurtherInfoPanel";
import SectionWrapper from "../../components/SectionWrapper";

const InfoRequestsPage = () => {
  const { caseId, infoRequestId } = useParams();
  const { contributors, data } = useSelector(state => state.caseDetail);

  const history = useHistory();

  useEffect(() => {
    if (data && data.isIntel)
      history.push(
        getRoute(urls.caseDetail, {
          caseId: data.id
        })
      );
  }, [data]);

  return (
    <SectionWrapper>
      {data && (
        <FurtherInfoPanel
          infoRequestId={infoRequestId}
          contributors={contributors}
          caseId={caseId}
        />
      )}
    </SectionWrapper>
  );
};

export default InfoRequestsPage;
